import { render } from "./pay-error.vue?vue&type=template&id=0e1228ef&scoped=true&ts=true"
import script from "./pay-error.vue?vue&type=script&lang=ts"
export * from "./pay-error.vue?vue&type=script&lang=ts"

import "./pay-error.vue?vue&type=style&index=0&id=0e1228ef&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e1228ef"]])

export default __exports__